import { motion, useSpring, useTransform } from "framer-motion";
import { useContext } from "react";
import CurrentContext from "../utils/CurrentContext";
import Carousel from "./carousel";
import styles from "./screenGame.module.scss";

export default function Game() {
  const {
    aspectRatio,
    quizImages,
    currentIndex,
    setAnswers,
    setCurrentIndex,
    setCurrentScreen,
    uploadUserDetails,
  } = useContext(CurrentContext);
  const values = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  const isLandscape = aspectRatio >= 1;

  const imageStyle = isLandscape
    ? { maxWidth: "100vh", maxHeight: "100vh" }
    : { maxWidth: "95vw", maxHeight: "95vw" };

  const ShowScreenResult = () => {
    setCurrentScreen("result");
  };

  const handleNextCard = () => {
    if (currentIndex < quizImages.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      uploadUserDetails();
      ShowScreenResult();
    }
  };

  const HandleAnswer = (direction) => {
    const current = quizImages[currentIndex];
    const isCorrect =
      (direction === "right" && current.label === "imagine") ||
      (direction === "left" && current.label === "real");

    setAnswers((prev) => [
      ...prev,
      { ...current, selected: direction, correct: isCorrect },
    ]);
  };

  function Animated({ i, z, vertPosition, value }) {
    const x = useSpring(0, { stiffness: 500, damping: 20 });
    // const x = useSpring(0, 1);
    const y = vertPosition;
    const rotate = useTransform(x, [-300, 300], [-15, 15]);

    const overlayOpacity = useTransform(
      x,
      [-300, -20, 0, 20, 300],
      [0.75, 0.75, 0, 0.75, 0.75]
    );

    const overlayColor = useTransform(
      x,
      [-50, 0, 50],
      ["rgba(0,0,0,1)", "rgba(0,0,0,0)", "rgba(236, 78, 11,1)"]
    );
    const overlayText = useTransform(x, (v) => {
      //   if (v < -20) return "It's Photoshoot";
      if (v < -20) return "Real";
      //   if (v > 20) return "Made by Imagine.io";
      if (v > 20) return "CGI";
      return "";
    });

    const isCurrent = value === currentIndex;
    const isPast = value < currentIndex;
    const isFuture = value > currentIndex;

    const dragEndHandler = (event, info) => {
      if (!isCurrent) return;

      const finalX = info.offset.x; // or use x.get() for spring value
      const finalXpercent = (finalX / window.innerWidth) * 100; // or use x.get() for spring value
      const velocityX = info.velocity.x;
      const threshhold = 30;

    //   console.log("Screen width:", window.innerWidth);
    //   console.log("Final drag X:", finalX);
      console.log("Final drag X%:", finalXpercent);
    //   console.log("Velocity X:", velocityX);

      if (x.getVelocity() >= 50 || finalXpercent > threshhold) {
        x.stop();
        x.set(3000);
        HandleAnswer("right");
        console.log("you selected right");
        handleNextCard();
      } else if (x.getVelocity() <= -50 || finalXpercent < -threshhold) {
        x.stop();
        x.set(-3000);
        HandleAnswer("left");
        console.log("you selected left");
        handleNextCard();
      } else {
        x.stop();
        x.set(0);
      }
    };

    // if (isPast) return null; // Don't render already swiped cards
    if (value < currentIndex || value > currentIndex + 1) return null;

    return (
      <motion.div
        className={styles.xyDisplacement}
        initial={{ y }}
        animate={{
          y,
          opacity: isCurrent ? 1 : 0.5,
          transition: {
            opacity: { duration: 0.4, ease: "easeOut" },
          },
        }}
        drag={isCurrent}
        dragConstraints={{ left: 0, right: 0, bottom: y, top: y }}
        whileHover={isCurrent ? { scale: 1.02 } : {}}
        whileDrag={{ scale: 0.85 }}
        onDragEnd={dragEndHandler}
        style={{
          x,
          z,
          rotate,
          pointerEvents: isCurrent ? "auto" : "none",
          scale: isCurrent ? 1 : 0.5, // only apply static scale to non-current cards
        }}
      >
        <img
          className={styles.image}
          src={quizImages[value].src}
          alt="currentimage"
          style={imageStyle}
        />
        <motion.div
          className={styles.overlay}
          style={{
            backgroundColor: overlayColor,
            opacity: overlayOpacity,
          }}
        >
          <motion.p className={styles.info}>{overlayText}</motion.p>
        </motion.div>
      </motion.div>
    );
  }

  return (
    <div className={styles.game_wrapper}>
      <div className={styles.slider_wrapper}>
        <motion.div className={styles.deck}>
          {[...values].reverse().map((value, i) => (
            <Animated
              i={-i}
              z={i}
              //   vertPosition={i * 10}
              vertPosition={0}
              key={i}
              value={value}
            />
          ))}
        </motion.div>
      </div>
      <Carousel />
    </div>
  );
}
